import tippy from 'tippy.js';

document.querySelectorAll('.loan-calculator').forEach((calculator) => {
    const defaultLoanRates = [
        { min: 0, max: 0, insured: 0, uninsured: 0 }
    ];

    const defaultLoanSettings = [
        { minAmount: 0, maxAmount: 0, maxTerm: 0 }
    ];

    const parseJsonData = (value, fallback) => {
        try {
            const parsed = JSON.parse(value || '');
            return Array.isArray(parsed) && parsed.length ? parsed : fallback;
        } catch (error) {
            return fallback;
        }
    };

    const loanRates = parseJsonData(calculator.dataset.loanRates, defaultLoanRates);
    const loanSettings = parseJsonData(calculator.dataset.loanSettings, defaultLoanSettings);

    const ranges = calculator.querySelectorAll('.loan-calculator__range');
    const rangeInputs = calculator.querySelectorAll('[data-range-input]');
    const amountRange = calculator.querySelector('[name="loanAmount"]');
    const termRange = calculator.querySelector('[name="loanTerm"]');
    const amountLabels = calculator.querySelectorAll('.loan-calculator__range-labels--amount span');
    const termLabels = calculator.querySelectorAll('.loan-calculator__range-labels--term span');
    const maximumTermLabel = calculator.querySelector('[data-maximum-term]');
    const insuranceInputs = calculator.querySelectorAll('[name="loanInsurance"]');
    const insuranceRateLabels = calculator.querySelectorAll('[data-insurance-rate]');

    // Summary Elementleri
    const summaryAmount = calculator.querySelector('.loan-calculator__summary-amount');
    const summaryTerm = calculator.querySelector('.loan-calculator__summary-term');
    const summaryInstallment = calculator.querySelector('.loan-calculator__summary-installment');
    const summaryInterest = calculator.querySelector('.loan-calculator__summary-interest');
    const summaryTotal = calculator.querySelector('.loan-calculator__summary-total');
    const paymentPlanLink = calculator.querySelector('.loan-calculator__payment-plan-link');
    const paymentPlanTable = document.querySelector('.loan-payment-plan__table');
    const paymentPlanBody = document.querySelector('.loan-payment-plan__body');
    const amountStep = Number(calculator.dataset.loanAmountStep) || 1000;
    const initialAmount = Number(calculator.dataset.loanAmountValue) || 100000;
    const termStep = Number(calculator.dataset.loanTermStep) || 1;
    const initialTerm = Number(calculator.dataset.loanTermValue) || 9;

    if (paymentPlanTable && !paymentPlanTable.parentElement.classList.contains('loan-payment-plan__table-scroll')) {
        const tableScroll = document.createElement('div');

        tableScroll.className = 'loan-payment-plan__table-scroll';
        paymentPlanTable.parentNode.insertBefore(tableScroll, paymentPlanTable);
        tableScroll.appendChild(paymentPlanTable);
    }

    tippy(calculator.querySelectorAll('[data-tooltip]'), {
        content(reference) {
            return reference.dataset.tooltip;
        },
        allowHTML: true,
        placement: 'top',
        trigger: 'mouseenter focus',
        theme: 'loan-calculator',
        maxWidth: 324,
    });

    // --- YARDIMCI FONKSİYONLAR ---

    // Vade ve sigorta durumuna göre dinamik faiz oranını getirir
    const getInterestRate = (term, insurance) => {
        const rateRow = loanRates.find(r => term >= r.min && term <= r.max);
        if (!rateRow) return 0;
        return insurance === 'insured' ? rateRow.insured : rateRow.uninsured;
    };

    const formatCurrency = (value, fractionDigits = 2) => Number(value).toLocaleString('tr-TR', {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });

    const clampToRange = (range, value) => {
        const minimum = Number(range.min);
        const maximum = Number(range.max);
        const step = Number(range.step) || 1;
        const currentValue = Number.isNaN(value) ? Number(range.value) : value;

        range.value = Math.min(Math.max(Math.round(currentValue / step) * step, minimum), maximum);
    };

    const minAmount = Math.min(...loanSettings.map(setting => setting.minAmount));
    const maxAmount = Math.max(...loanSettings.map(setting => setting.maxAmount));
    const minTerm = Math.min(...loanRates.map(rate => rate.min));
    const maxTerm = Math.max(...loanRates.map(rate => rate.max));
    const maxConfiguredTerm = Math.max(...loanSettings.map(setting => setting.maxTerm));

    amountRange.min = minAmount;
    amountRange.max = maxAmount;
    amountRange.step = amountStep;
    termRange.min = minTerm;
    termRange.max = Math.min(maxTerm, maxConfiguredTerm);
    termRange.step = termStep;
    clampToRange(amountRange, initialAmount);
    clampToRange(termRange, initialTerm);

    amountLabels[0].textContent = `${formatCurrency(minAmount, 0)} TL`;
    amountLabels[1].textContent = `${formatCurrency(maxAmount, 0)} TL`;
    termLabels[0].textContent = `${minTerm} Ay`;
    termLabels[1].textContent = `${termRange.max} Ay`;

    const updateRange = (range) => {
        const output = calculator.querySelector(`[data-range-input="${range.id}"]`);
        const progress = ((range.value - range.min) / (range.max - range.min)) * 100;

        range.style.setProperty('--range-progress', `${progress}%`);

        if (range.name === 'loanAmount') {
            output.value = formatCurrency(range.value, 0);
        }

        if (range.name === 'loanTerm') {
            output.value = range.value;
        }

        output.style.width = range.name === 'loanTerm' ? '2ch' : '8ch';
    };

    const updateTermLimit = () => {
        const amount = Number(amountRange.value);
        const setting = loanSettings.find(item => amount >= item.minAmount && amount <= item.maxAmount);
        const maximumTerm = Math.min(setting ? setting.maxTerm : maxConfiguredTerm, maxTerm);

        termRange.max = maximumTerm;

        if (Number(termRange.value) > maximumTerm) {
            termRange.value = maximumTerm;
        }

        maximumTermLabel.textContent = `${maximumTerm} Ay`;

        updateRange(termRange);
    };

    // --- HESAPLAMA MANTIKLARI ---

    const updateSummary = () => {
        const amount = Number(amountRange.value);
        const term = Number(termRange.value);
        const insurance = calculator.querySelector('[name="loanInsurance"]:checked').value;

        const interestRate = getInterestRate(term, insurance);
        const monthlyNetRate = interestRate / 100;
        const monthlyGrossRate = monthlyNetRate * 1.30; // KKDF + BSMV dahil brüt oran

        // Taksit Tutarı Hesaplama (Brüt Oran Üzerinden)
        const installment = amount * monthlyGrossRate * ((1 + monthlyGrossRate) ** term)
            / (((1 + monthlyGrossRate) ** term) - 1);

        insuranceRateLabels.forEach((label) => {
            label.textContent = `%${formatCurrency(getInterestRate(term, label.dataset.insuranceRate))}`;
        });

        summaryAmount.textContent = `${formatCurrency(amount, 0)} TL`;
        summaryTerm.textContent = `${term} ay`;
        summaryInstallment.textContent = `₺${formatCurrency(installment)} TL`;
        summaryInterest.textContent = `%${formatCurrency(interestRate)}`;
        summaryTotal.textContent = `₺${formatCurrency(installment * term)} TL`;
    };

    const getPaymentDate = (monthOffset) => {
        const date = new Date();

        date.setMonth(date.getMonth() + monthOffset);

        return date.toLocaleDateString('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    };

    const createPaymentPlan = () => {
        const amount = Number(amountRange.value);
        const term = Number(termRange.value);
        const insurance = calculator.querySelector('[name="loanInsurance"]:checked').value;

        const interestRate = getInterestRate(term, insurance);
        const monthlyNetRate = interestRate / 100;
        const monthlyGrossRate = monthlyNetRate * 1.30;

        // Sabit Taksit
        const installment = amount * monthlyGrossRate * ((1 + monthlyGrossRate) ** term)
            / (((1 + monthlyGrossRate) ** term) - 1);

        let remainingPrincipal = amount;

        paymentPlanBody.innerHTML = Array.from({ length: term }, (_, index) => {
            // Faiz o ayki kalan borç üzerinden net oranla hesaplanır (her ay azalır)
            const interestAmount = remainingPrincipal * monthlyNetRate;

            const kkdf = interestAmount * 0.15;
            const bsmv = interestAmount * 0.15;

            // Anapara payı = Taksit - (Faiz + KKDF + BSMV)
            const principalAmount = installment - (interestAmount + kkdf + bsmv);
            remainingPrincipal = Math.max(remainingPrincipal - principalAmount, 0);

            return `
                <tr>
                    <td>${index + 1}</td>
                    <td>${getPaymentDate(index + 1)}</td>
                    <td class="loan-payment-plan__installment">₺${formatCurrency(installment)}</td>
                    <td>₺${formatCurrency(principalAmount)}</td>
                    <td>₺${formatCurrency(interestAmount)}</td>
                    <td>₺${formatCurrency(kkdf)}</td>
                    <td>₺${formatCurrency(bsmv)}</td>
                    <td class="loan-payment-plan__remaining">₺${formatCurrency(remainingPrincipal)}</td>
                    <td>%${formatCurrency(interestRate)}</td>
                    <td>%${formatCurrency(interestRate * 12)}</td>
                </tr>
            `;
        }).join('');
    };

    const preventBackgroundScroll = (event) => {
        if (event.target.closest('.loan-payment-plan__table-scroll')) {
            return;
        }

        event.preventDefault();
    };

    const setPaymentPlanModalClass = (instance) => {
        if (instance && instance.$refs && instance.$refs.container) {
            instance.$refs.container.addClass('loan-payment-plan-fancybox');
        }
    };

    const removePaymentPlanModalClass = (instance) => {
        if (instance && instance.$refs && instance.$refs.container) {
            instance.$refs.container.removeClass('loan-payment-plan-fancybox');
        }
    };

    const lockPageScroll = (instance) => {
        setPaymentPlanModalClass(instance);
        document.documentElement.classList.add('loan-modal-open');
        document.body.classList.add('loan-modal-open');
        document.addEventListener('touchmove', preventBackgroundScroll, { passive: false });
    };

    const unlockPageScroll = (instance) => {
        removePaymentPlanModalClass(instance);
        document.documentElement.classList.remove('loan-modal-open');
        document.body.classList.remove('loan-modal-open');
        document.removeEventListener('touchmove', preventBackgroundScroll);
    };

    // --- EVENT LISTENERS ---

    ranges.forEach((range) => {
        range.addEventListener('input', () => {
            updateRange(range);

            if (range === amountRange) {
                updateTermLimit();
            }

            updateSummary();
        });
        updateRange(range);
    });

    rangeInputs.forEach((input) => {
        const range = calculator.querySelector(`#${input.dataset.rangeInput}`);

        input.addEventListener('change', () => {
            const rawValue = Number(input.value.replace(/\D/g, ''));
            const minimum = Number(range.min);
            const maximum = Number(range.max);
            const step = Number(range.step);
            const value = Number.isNaN(rawValue) ? Number(range.value) : rawValue;

            range.value = Math.min(Math.max(Math.round(value / step) * step, minimum), maximum);

            if (range === amountRange) {
                updateTermLimit();
            }

            updateRange(range);
            updateSummary();
        });
    });

    insuranceInputs.forEach((input) => {
        input.addEventListener('change', updateSummary);
    });

    paymentPlanLink.addEventListener('click', () => {
        createPaymentPlan();
    });
    $(paymentPlanLink).fancybox({
        buttons: [],
        afterClose: unlockPageScroll,
        beforeShow: lockPageScroll,
        smallBtn: false,
        toolbar: false,
    });

    // İlk çalıştırma
    updateTermLimit();
    updateSummary();
});
